declare global {
    interface CSSStyleDeclaration {
        WebkitOverflowScrolling: string;
    }
}

// based on https://github.com/lazd/iNoBounce
export class IOSScrollFix {
    protected startY: number = 0;
    protected maxDistance: number = 0;
    protected needClick: boolean = false;
    protected startElement: HTMLElement | null = null;

    public enable(): void {
        const testDiv: HTMLDivElement = document.createElement('div');
        document.documentElement.appendChild(testDiv);
        testDiv.style.WebkitOverflowScrolling = 'touch';
        const scrollSupport: boolean = 'getComputedStyle' in window && window.getComputedStyle(testDiv)['-webkit-overflow-scrolling'] === 'touch';
        document.documentElement.removeChild(testDiv);

        if (scrollSupport) {
            window.addEventListener('touchstart', this.handleTouchstart, false);
            window.addEventListener('touchmove', this.handleTouchmove, false);
            window.addEventListener('touchend', this.handleTouchEnd, false);
        }
    }

    protected handleTouchstart = (evt: TouchEvent | MouseEvent): void => {
        this.startY = (evt as TouchEvent).touches ? (evt as TouchEvent).touches[0].screenY : (evt as MouseEvent).screenY;
        this.needClick = false;
        this.startElement = evt.target as HTMLElement;
        this.maxDistance = 0;
    };

    protected handleTouchmove = (evt: TouchEvent | MouseEvent): void => {
        let el: HTMLElement = evt.target as HTMLElement;
        while (el !== document.body) {
            const style: CSSStyleDeclaration = window.getComputedStyle(el);
            if (!style) {
                break;
            }
            if (el.nodeName === 'INPUT' && el.getAttribute('type') === 'range') {
                return;
            }
            const scrolling: string = style.getPropertyValue('-webkit-overflow-scrolling');
            const overflowY: string = style.getPropertyValue('overflow-y');
            const height: number = parseInt(style.getPropertyValue('height'), 10);

            // Determine if the element should scroll
            const isScrollable: boolean = scrolling === 'touch' && (overflowY === 'auto' || overflowY === 'scroll');
            const canScroll: boolean = el.scrollHeight > el.offsetHeight;
            if (isScrollable && canScroll) {
                const curY: number = (evt as TouchEvent).touches ? (evt as TouchEvent).touches[0].screenY : (evt as MouseEvent).screenY;
                const isAtTop: boolean = (this.startY <= curY && el.scrollTop === 0);
                const isAtBottom: boolean = (this.startY >= curY && el.scrollHeight - el.scrollTop === height);
                if (isAtTop || isAtBottom) {
                    evt.preventDefault();
                    this.setClickReminder(evt);
                }
                return;
            }
            el = el.parentNode as HTMLElement;
        }
        evt.preventDefault();
        this.setClickReminder(evt);
    };

    protected setClickReminder = (evt: TouchEvent | MouseEvent): void => {
        if ( this.startElement != null) {
            const curX: number = (evt as TouchEvent).touches ? (evt as TouchEvent).touches[0].screenX : (evt as MouseEvent).screenX;
            const curY: number = (evt as TouchEvent).touches ? (evt as TouchEvent).touches[0].screenY : (evt as MouseEvent).screenY;
            const clientRect: ClientRect = this.startElement.getBoundingClientRect();
            this.maxDistance = Math.max(this.maxDistance, Math.abs(curY - this.startY));
            this.needClick = (
                clientRect.top < curY &&
                clientRect.bottom > curY &&
                clientRect.left < curX &&
                clientRect.right > curX
            );
        }
    };

    protected handleTouchEnd = (evt: TouchEvent | MouseEvent): void => {
        if (this.needClick && this.maxDistance < 100 && this.startElement != null && this.startElement === evt.target) {
            const event: MouseEvent = new MouseEvent(
                'click', {
                    view: window,
                    bubbles: true,
                    cancelable: true
                }
            );
            this.startElement.dispatchEvent(event);
        }
        this.needClick = false;
        this.startElement = null;
        this.maxDistance = 0;
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/IOSScrollFix.ts